import { useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Table from 'src/features/base/components/Table'
import {
  selectProductMovementsByType,
  selectProductTabFilters,
} from 'src/features/stock-management/StockManagementSeletor'
import { actions } from 'src/features/stock-management/StockManagementState'
import { useLast12Months } from 'src/utils'
import { formatterMonthDate } from 'src/utils/formatDate'
import { mapMovementTypeForTab } from 'src/utils/mappers/mapMovementType'
import lodash from 'lodash'

export default () => {
  const dispatch = useDispatch()
  const productMovementsByType = useSelector(selectProductMovementsByType)
  const { fulfillmentCenterId, modelId } = useSelector(selectProductTabFilters)
  const last12Months = useLast12Months()

  useEffect(
    () => () => {
      dispatch(actions.clearMovementsByTypeTab())
    },
    [dispatch, fulfillmentCenterId, modelId],
  )
  const numberAlignRight = () => ({
    style: {
      textAlign: 'right',
    },
  })

  const headerColumns = useMemo(() => productMovementsByType[0]
    ?.balances
    ?.map(({ date }) => ({
      Header: formatterMonthDate(date),
      id: date,
      accessor: date,
      width: 90,
      getProps: numberAlignRight,
    })), [productMovementsByType])

  const movements = useMemo(() => productMovementsByType
    ?.map(({ type, balances }) => {
      const lastTwelveBalance = balances.reduce((acc, { date, balance }) => {
        acc[date] = balance
        return acc
      }, {})
      // eslint-disable-next-line dot-notation
      lastTwelveBalance['type'] = mapMovementTypeForTab(type)
      return lastTwelveBalance
    }), [productMovementsByType])

  const getRows = (movementsArray) => (movementsArray.map((move) => {
    const values = lodash.values(move)
    values.pop()
    const sum = values.reduce((a, b) => a + parseInt(b, 10), 0)
    return {
      ...move,
      total: sum,
    }
  }))

  return (
    <Table
      data={getRows(movements) || []}
      columns={[
        {
          Header: 'Tipo', id: '1', accessor: 'type', width: 80,
        },
        ...headerColumns || last12Months,
        {
          Header: 'Total', id: '2', accessor: 'total', width: 60, getProps: numberAlignRight,
        },
      ]}
    />
  )
}
